<template>
<div class="audioPlay" v-show="isShowAudioPlayer">
  <audio ref="audio" v-if="isShowAudioPlayer" autoplay="autoplay"  @ended.stop="audioEnded" :src="url" controls @loadedmetadata="loadedmetadata" @timeupdate.stop="updateProgress"></audio>
   <div class="process" :style="{width:percentBar}"></div>
   <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%206%402x.png" class="logo"/>
   <div class="center">
      <div class="title ellipsis">{{index+1}} | {{info.name}}</div>
      <!-- <div class="time">13:21 托育高研院官方账号</div> -->
   </div>
   <img :src="isPlay ? pause: play" class="play" @click="playAudio"/>
   <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E5%85%B3%E9%97%AD26%402x.png" class="close" @click="toClose"/>
</div>
</template>

<script>
export default {
  data() {
    return {
      duration:0,
      info:{},
      currentTime:'',
      totalTime:0,
      timeStart:0,
      list:[],
      index:0,
      isShowAudioPlayer:false,
      isPlay:false,
      pause:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%202%E5%A4%87%E4%BB%BD%204%402x.png',
      play:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%202%E5%A4%87%E4%BB%BD%203%402x.png',
      percentBar:0,
      autoplay:true,
      url:''
    };
  },
  props:{
    goods_course_id:{
      default: null,
    },
  },
  computed: {
     plat() {
      return this.$store.state.plat_id
    },
    currentInfo(){
      return this.list[this.index]
     },
  },
  methods: {
    getData(list,index){
        this.index = index
        this.info = list[index]
        this.url = this.info.video_ids[0].resource[0].url
        this.isShowAudioPlayer = true
    },
    toClose(){
       this.isShowAudioPlayer = false
       this.addHistory()
    },
    // 音频初始化完成获取秒数
        loadedmetadata(event) {
            // this.progressBoxWidth = this.$refs.progressBox.offsetWidth
            // console.log('progressBoxWidth:',this.progressBoxWidth)
            console.log('录音时长：',event.target.duration,event)
            this.totalTime = parseInt(event.target.duration,event)
            // this.$set(this.audioData,'duration',this.transTime(event.target.duration))
            this.isPlay = true
            // this.$forceUpdate()
            this.$nextTick(()=>{
              console.log('播放')
              this.$refs.audio.play()
              this.timeStart = new Date()
            })
        },
        // 音频播放位置发生改变-进度条播放的事件
        updateProgress() {
            let audio = this.$refs.audio
            // let value = Math.round((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100, 0)
            let value = ((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100).toFixed(2)
            // this.$set(this.audioData,'currentTime',this.transTime(audio.currentTime))
            this.percentBar = `${value}%`
            this.$forceUpdate()
            // console.log('音频进度条改变：',this.percentBar)
            this.currentTime = parseInt(audio.currentTime)
            this.progressWidth = Math.round(Math.floor(audio.currentTime) * this.progressBoxWidth / Math.floor(audio.duration))+'px'
        },
        // 播放结束的处理动作
        audioEnded() {
            console.log('播放结束')
            this.isPlay = false
            let audio = this.$refs.audio
            // audio.currentTime = 0
            this.addHistory()
            audio.pause()
        },
        playAudio() {
            let audio = this.$refs.audio
            this.isPlay = !this.isPlay
            if(this.isPlay) {
                audio.play()
                this.timeStart = new Date()
            }else {
                audio.pause()
                this.addHistory()
            }
        },
        // 点击进度条
        clickProgress(event) {
            this.progressBoxWidth = this.$refs.progressBox.offsetWidth
            console.log('progressBoxWidth:',this.progressBoxWidth)
            console.log('点击进度条：',event)
            var duration = this.$refs.audio.duration
            var currentTime = Math.floor(event.offsetX * duration / this.progressBoxWidth) 
            this.$refs.audio.currentTime = currentTime
            console.log(currentTime,'---',this.$refs.audio.currentTime)
            // this.$set(this.audioData,'currentTime',this.transTime(currentTime))
            // this.progressWidth = event.offsetX >= this.progressBoxWidth ? event.offsetX+'px' : this.progressBoxWidth+'px'
        },
        // 滑块移动
        progressMove(event) {
            console.log('滑块移动：',event)
            var duration = this.$refs.audio.duration
            this.$set(this.audioData,'duration',this.transTime(duration))
            var currentTime = Math.floor((this.touchStartBarWidth+event.touches[0].clientX - this.touchStartX) * duration / this.progressBoxWidth)
            currentTime >= duration ? duration : currentTime
            this.$refs.audio.currentTime = currentTime
            // this.$set(this.audioData,'currentTime',this.transTime(currentTime))
        },
        // 滑块开始触摸
        touchstart(event) {
            console.log('滑块开始触摸:',event)
            this.touchStartX = event.touches[0].clientX
            this.touchStartBarWidth = this.$refs.progressBar.offsetWidth
        },
        // 将秒数转化成(分:秒)格式
        transTime(time) {
            let duration = parseInt(time)
            let minute = parseInt(duration / 60).toString().padStart(2, '0')
            let sec = (duration % 60).toString().padStart(2, '0')
            return `${minute}:${sec}`
        },
        async addHistory() {
          console.log("history");
          let data = this.info;
          this.duration = this.timeStart
            ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000)
            : 0;
          console.log(this.duration);
          // if(!data || this.duration<5) return
          this.timeStart = 0;
          let res = await this.$request.tuoyuRecord({
            lesson_id:
            data.myType && data.myType == "lesson"
                ? data.id
                : 0,
            chapter_id: data.myType ? 0 : data.id,
            speak_id:
            data.myType && data.myType == "speak"
                ? data.id
                : 0,
            goods_course_id: this.goods_course_id,
            status: this.currentTime && (this.totalTime - this.currentTime) < 6  ? 1 : 0,
            duration: this.duration,
            flat_id: this.plat,
            playmode_id: data.video_ids[0].id,
          });
        },
  },
};
</script>

<style scoped>
audio {
    position: absolute;
    top: 0;
    display: block;
    height: 0;
    width: 0;
    opacity: 0;
}
.audioPlay{
  position: fixed;
  z-index: 100;
  bottom:0;
  border-bottom: 5px solid #F5F5F5;
  left:0;
  width: 100vw;
  height: 122px;
  background: #fff;
  display: flex;
  align-items: center;
}
.audioPlay .process{
  position: absolute;
  bottom:-5px;
  height: 5px;
  left: 0;
  background-color: #A7090A;
}
.audioPlay .logo{
  width: 74px;
  height: 74px;
  margin-left: 28px;
  margin-right: 21px;
}
.audioPlay .play{
  width: 56px;
  height: 56px;
  margin: 0 28px;
}
.audioPlay .close{
  width: 20px;
  height: 20px;
  margin-right: 21px;
}
.audioPlay .center{
  flex:1;
  height: 70px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.audioPlay .center .title{
  font-size: 26px;
}
.audioPlay .center .time{
  font-size: 22px;
  color: #999999;
}
</style>>
